import { Button, DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { dbDateFormat } from "../../../constants/constants";
import { useUpdatePreviousAllGeneralMutation } from "../../../features/shiftAssignToEmployee/shiftAssignToEmployeeApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { disableFutureDates } from "../../../lib/time";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";
import SuccessModal from "../../Report/SuccessModal";
import ConfirmModal from "../../ui/ConfirmModal";
import CustomModal from "../../ui/CustomModal";

const { RangePicker } = DatePicker;

export default function PreviousGeneralAttendance({
  handleClose,
  ...rest
}: ModalComponentProps) {
  // const navigate = useNavigate();
  const [dates, setDates] = useState<[Dayjs, Dayjs]>([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);
  const {
    open,
    handleOpen,
    handleClose: handleConfirmClose,
  } = useModal<undefined, "CONFIRM" | "SUCCESS">();
  const [updatePreviousAllGeneral, { isLoading, isSuccess, isError, error }] =
    useUpdatePreviousAllGeneralMutation();
  useError(isError, error, "Update previous general status fail");

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Previous status updated successfully");
      // handleConfirmClose();
      // handleClose();
      handleOpen({ type: "SUCCESS" });
      // if (data?.data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <CustomModal {...rest} handleClose={handleClose} footer={null}>
      {open?.type === "SUCCESS" && (
        <SuccessModal
          type="queue"
          open={open?.open}
          handleClose={handleConfirmClose}
        />
      )}

      {open?.type === "CONFIRM" && (
        <ConfirmModal
          open={open?.open}
          handleOk={() => {
            updatePreviousAllGeneral({
              start_date: dates[0].format(dbDateFormat),
              end_date: dates[1].format(dbDateFormat),
            });
          }}
          handleClose={handleConfirmClose}
          okText="Confirm"
          confirmTitle="Update previous shift to general"
          questionText="Do you want to update the previous day's shift to general for all active users?"
          okLoading={isLoading}
        />
      )}
      <div>
        <div className="text-center pt-4 mb-2 font-medium text-header text-2xl">
          Select previous date range to update all active user to general
        </div>
        <div className="flex justify-center items-center mt-4 mb-4">
          <RangePicker
            className="my-2 clear-button-hide"
            value={dates}
            disabledDate={disableFutureDates}
            onChange={(d) => {
              if (d) setDates(d as [Dayjs, Dayjs]);
            }}
          />
        </div>{" "}
        <div className="flex flex-col items-center gap-4 mt-4 mb-4">
          <Button
            className="modal-button w-[250px]"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
            onClick={() => {
              handleOpen({ type: "CONFIRM" });
            }}
          >
            Update previous shift to general
          </Button>
          <Button
            className="normal-dark-button modal-button  w-[250px]"
            onClick={handleClose}
            size="middle"
          >
            Close
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
